import { render, staticRenderFns } from "./progressBar.vue?vue&type=template&id=60774d72"
import script from "./progressBar.vue?vue&type=script&lang=js"
export * from "./progressBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports